import {createStore} from "vuex";
import {createPersistedState} from "./persistedState";
import authStore from "./auth.store";
import kycStore from "./kyc.store";
import makeInvestmentStore from "./makeInvestment.store";
import calculatorsStore from "@/store/calculators";
import goalsStore from "@/store/goals.store";
import assetTrackerStore from "./assetTracker.store";
import streakStore from "./streak.store";

export function persistedStateReducer(state) {
  const { assetTracker, ...rest } = state;
  return {
    ...rest,
    assetTracker: { selectedCurrencyView: assetTracker.selectedCurrencyView },
  };
}

const modules = {
    auth: authStore,
    makeInvestment: makeInvestmentStore,
    kyc: kycStore,
    calculator: calculatorsStore,
    goals: goalsStore,
    assetTracker: assetTrackerStore,
    streak: streakStore,
};
function defaults(module) {
  const state = typeof module.state === "function" ? module.state() : structuredClone(module.state || {});
  for (const [key, child] of Object.entries(module.modules || {})) state[key] = defaults(child);
  return state;
}
const initialState = defaults({ modules });
export default createStore({
  modules,
  mutations: {
    resetSession(state) {
      try { globalThis.localStorage?.removeItem("vuex"); } catch { /* In-memory reset still applies. */ }
      for (const key of Object.keys(state)) delete state[key];
      Object.assign(state, structuredClone(initialState));
    },
  },
  plugins: [createPersistedState({
    reducer: persistedStateReducer,
  })],
});
